// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Axhh","col":"styles_col__VFrCC","actions":"styles_actions__kgsYc","conflict":"styles_conflict__1b8wQ"};